<template>
  <div class="ma-6">
    <DialogSukseskanTrx/>
    <div class="page-header-left">
      <h2 class="pr-3">Transaksi</h2>
      <v-spacer></v-spacer>
      <div class="listtotal">
        <v-card style="border: thin solid rgba(0,0,0,.12)" class="listtotal border_all mr-2" elevation="0">
          <v-sheet class="" color="green" width="50" height="50" elevation="0">
            <v-icon dark large class="icondash">shopping_cart</v-icon>
          </v-sheet>
          <div class="pl-2 pr-10">
            <div>Total Trx</div>
            <div>{{formatAngka(sumtrx[0])}}</div>
          </div>
        </v-card>
        <v-card class="listtotal" style="border: thin solid rgba(0,0,0,.12)" elevation="0">
          <v-sheet class="" color="green" width="50" height="50" elevation="0">
            <v-icon dark large class="icondash">shopping_cart</v-icon>
          </v-sheet>
          <div class="pl-2 pr-10">
            <div>Amount Trx</div>
            <div>{{formatAngka(sumtrx[1])}}</div>
          </div>
        </v-card>
      </div>
    </div>
    <div class="mt-4 pr-0 pl-0 pt-2 border_all" style="border: thin solid rgba(0,0,0,.12)" elevation="0">
      <v-toolbar elevation="0">
        <v-text-field
            flat
            solo
            clearable
            prepend-icon="search"
            placeholder="Type something"
            v-model="opsitabletrx.search"
            hide-details
            class=""
        ></v-text-field>
        <v-spacer></v-spacer>
        <div class="mt-6">
          <v-select
              clearable
              label="Status Transaksi"
              item-text="label"
              item-value="id"
              v-model="opsitabletrx.statustrx"
              :items="trxstatuses"
          ></v-select>
        </div>
        <div class="mt-6">
          <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="opsitabletrx.awal"
                  label="Tanggal Awal"
                  prepend-icon="event"
                  readonly
                  v-bind="attrs"
                  v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="opsitabletrx.awal" @input="menu1 = false"></v-date-picker>
          </v-menu>
        </div>
        <div class="mt-6">
          <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="opsitabletrx.akhir"
                  label="Tanggal Akhir"
                  prepend-icon="event"
                  readonly
                  v-bind="attrs"
                  v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="opsitabletrx.akhir" @input="menu2 = false"></v-date-picker>
          </v-menu>
        </div>
        <v-btn small elevation="0" class="ml-2" color="primary" @click.native="getAdminTrx(opsitabletrx)">
          <v-icon dark>refresh</v-icon>Refresh
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-data-table
          dense
          sort-by="id"
          :sort-desc="sortdes"
          :headers="headers"
          :search="search"
          :items="trxadmin"
          class="elevation-0"
          item-key="id"
          :options.sync="opsitabletrx"
          :server-items-length="totaltrxadmin"
          :loading="loading"
          @update:options="getAdminTrx(opsitabletrx)">
        <template v-slot:item.transactionrc="{ item }">
          <div class="ma-4 text-xs-left">
            <v-chip
                :color="colorStatus(item.transactionrc)"
                small
                text-color="white">
              {{ trxstatusText(item.transactionrc) }}
            </v-chip>
          </div>
        </template>
        <template v-slot:item.sellprice="{ item }">
          <div  class="text-right">
            {{formatAngka(item.sellprice)}}
          </div>
        </template>
        <template v-slot:item.productcode="{ item }">
          {{toupper(item.productcode)}}
        </template>
        <template v-slot:item.createat="{ item }">
          {{formatDate(item.createat)}}
        </template>
        <template v-slot:item.updateat="{ item }">
          {{formatDate(item.updateat)}}
        </template>
        <template v-slot:item.aksi="{ item }">
          <v-container>
              <v-row>
                <v-btn v-if="item.transactionrc===0" x-small dark fab text @click.native="gagalkan(item)" class="red ml-2">
                  <v-icon small>delete</v-icon>
                </v-btn>
                <v-btn v-if="item.transactionrc===1" small dark text @click.native="refund(item)" class="red ml-2">
                  <v-icon small>delete</v-icon>
                  Refund
                </v-btn>
                <v-btn v-if="item.transactionrc===0" x-small dark fab text @click.native="opensukseskan(item)" class="green ml-2">
                  <v-icon small>done</v-icon>
                </v-btn>
              </v-row>
          </v-container>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import Utils from '@/plugins/utils'
import DialogSukseskanTrx from '@/components/admin/DialogSukseskanTrx'

export default {
  name: 'TransaksiAdmin',
  components: { DialogSukseskanTrx },
  data: () => ({
    search: '',
    tab: '',
    menu1: false,
    menu2: false,
    sortdes: [true],
    dateawal: moment().add(7, 'hours').toISOString().substr(0, 10),
    dateakhir: moment().add(7, 'hours').toISOString().substr(0, 10),
    opsitabletrx: {
      search: '',
      itemsPerPage: 10,
      page: 1,
      statustrx: '',
      sortBy: ['id'],
      awal: moment().add(7, 'hours').toISOString().substr(0, 10),
      akhir: moment().add(7, 'hours').toISOString().substr(0, 10)
    },
    trxstatuses: [
      {
        id: 0,
        label: 'Pending'
      },
      {
        id: 1,
        label: 'Sukses'
      },
      {
        id: 2,
        label: 'Gagal'
      }
    ],
    headers: [
      {
        text: 'TrxId',
        value: 'id'
      },
      {
        text: 'Waktu',
        value: 'createat'
      },
      {
        text: 'Client Ref',
        value: 'reffclient'
      },
      {
        text: 'Kode',
        value: 'productcode'
      },
      {
        text: 'Produk',
        value: 'productname'
      },
      {
        text: 'Tujuan',
        value: 'target'
      },
      {
        text: 'Harga',
        value: 'sellprice'
      },
      {
        text: 'Pembeli',
        value: 'membername'
      },
      {
        text: 'Penjual',
        value: 'sellername'
      },
      {
        text: 'Status',
        value: 'transactionrc'
      },
      {
        text: 'SerialNumber',
        value: 'serialnumber'
      },
      {
        text: 'Keterangan',
        value: 'description'
      },
      {
        text: 'Update',
        value: 'updateat'
      },
      {
        text: 'Aksi',
        value: 'aksi',
        sortable: false,
        width: 120
      }
    ]
  }),
  mounted () {
  },
  computed: {
    ...mapState('TrxAdmin', ['dialog', 'sumtrx', 'loading', 'trxadmin', 'totaltrxadmin'])
  },
  methods: {
    ...mapActions('TrxAdmin', ['getSumTrx', 'setdialog', 'setloading', 'getAdminTrx', 'setdialogsukseskan', 'setselectedtrx', 'updateStatusTrx']),
    formatAngka (val) {
      return Utils.formatAngka(val)
    },
    formatDate (value) {
      return moment(value).add(0, 'hours').format('YYYY/MM/DD HH:mm:ss')
    },
    opensukseskan (item) {
      this.setselectedtrx(item)
      this.setdialogsukseskan(true)
    },
    opendetail (item) {
      console.log(item)
    },
    colorStatus (val) {
      if (val === 0) {
        return 'blue'
      }
      if (val === 1) {
        return 'green'
      }
      if (val === 2) {
        return 'red'
      }
    },
    toupper (val) {
      return val.toUpperCase()
    },
    trxstatusText (val) {
      if (val === 0) {
        return 'PENDING'
      }
      if (val === 1) {
        return 'SUKSES'
      }
      if (val === 2) {
        return 'GAGAL'
      }
    },
    gagalkan (val) {
      var trx = val
      this.$confirm('Yakin akan gagalkan Trx ' + trx.productname + ' ' + trx.membername + ' Penjual ' + trx.sellername, { color: 'red', title: 'Konfirmasi', icon: 'fa-question' }).then(res => {
        if (res) {
          console.log(trx)
          this.updateStatusTrx({ idtrx: trx.id, status: 2 })
        }
      })
    },
    refund (val) {
      var trx = val
      this.$confirm('Yakin akan Refund Trx ' + trx.productname + ' ' + trx.target + '  ' + trx.membername + ' Penjual ' + trx.sellername, { color: 'orange', title: 'Konfirmasi', icon: 'fa-question' }).then(res => {
        if (res) {
          console.log(trx)
          this.updateStatusTrx({ idtrx: trx.id, status: 2 })
        }
      })
    }
  }
}
</script>

<style scoped>
.listtotal {
  display:flex;
  flex-wrap: wrap;
}
.icondash {
  margin-left: 6px;
  margin-top: 5px;
}
</style>
